import { Service } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Service()
export class DialogService {
  private zoomInfo = new Subject<any>();

  getZoomInfo(): Observable<any> {
    return this.zoomInfo;
  }

  setZoomInfo(zoomInfo: any) {
    this.zoomInfo.next(zoomInfo);
  }
}
